import { render, staticRenderFns } from "./DownloadInfo.vue?vue&type=template&id=1dee0536&scoped=true&"
import script from "./DownloadInfo.vue?vue&type=script&lang=js&"
export * from "./DownloadInfo.vue?vue&type=script&lang=js&"
import style0 from "./DownloadInfo.vue?vue&type=style&index=0&id=1dee0536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee0536",
  null
  
)

export default component.exports